"use client";

import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Backdrop } from "@mui/material";

export const CookieModal = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasConsented = localStorage.getItem("cookies_accepted");
    if (!hasConsented) {
      setShowModal(true);
    }
  }, []);

  const handleAction = (status: "accept" | "decline") => {
    localStorage.setItem("cookies_accepted", status);
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <Backdrop
      sx={{ 
        backgroundColor: "rgba(0, 0, 0, 0.75)", 
        backdropFilter: "blur(2px)",
        zIndex: (theme) => theme.zIndex.drawer + 1 
      }}
      open={showModal}
    >
      <Box
        sx={{
          backgroundColor: "#ffffff",
          width: "90%",
          maxWidth: "700px", 
          boxShadow: "0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)",
          borderRadius: "16px",
          padding: { xs: "24px", sm: "32px" },
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Box>
          <Typography variant="h5" sx={{ color: "#111827", fontWeight: 800, mb: 1 }}>
            Kami Menghargai Privasi Anda
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: "black", 
              lineHeight: 1.7 
            }}
          >
            Kami menggunakan cookies untuk meningkatkan pengalaman penelusuran Anda, menganalisis lalu lintas situs, dan memberikan konten yang lebih relevan. Dengan melanjutkan, Anda dapat menyetujui atau menolak penggunaan cookies sesuai dengan Kebijakan Privasi kami.
          </Typography>
        </Box>
        
        <Box 
          sx={{ 
            display: "flex", 
            gap: 2, 
            justifyContent: "center",
            flexDirection:"column",
            mt: 1
          }}
        >
          <Button 
            variant="contained" 
            onClick={() => handleAction("accept")}
            sx={{ 
              backgroundColor: "#2563EB", 
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 24px",
              fontSize: "0.9rem",
              "&:hover": {
                backgroundColor: "#1D4ED8",
              },
            }}
          >
            Terima
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => handleAction("decline")}
            sx={{ 
              color: "#4B5563", 
              borderColor: "#D1D5DB",
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "8px 24px",
              fontSize: "0.9rem",
              "&:hover": {
                borderColor: "#9CA3AF",
                backgroundColor: "#F3F4F6",
              }
            }}
          >
            Tolak
          </Button>         
        </Box>
      </Box>
    </Backdrop>
  );
};